import React from 'react';
import './NoProductFound.css';

const NoProductFound: React.FC = () => {
  return (
    <div className="no-product-found-container">
      <button className="no-product-found-button">
        NO PRODUCT FOUND
      </button>
    </div>
  );
};

export default NoProductFound;
